import { useSyncExternalStore } from 'react';

/**
 * Диалог создания проекта — один на приложение, живёт в оболочке, а не в
 * сайдбаре: сайдбар на телефоне — выдвижная панель, и диалог, рождённый
 * внутри неё, исчезал вместе с ней. Кнопки «+» лишь просят его открыть.
 */
let open = false;
const listeners = new Set<() => void>();

function emit(): void {
  for (const listener of listeners) {
    listener();
  }
}

export function openCreateSpace(): void {
  open = true;
  emit();
}

export function setCreateSpaceOpen(next: boolean): void {
  open = next;
  emit();
}

export function useCreateSpaceOpen(): boolean {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);

      return () => {
        listeners.delete(listener);
      };
    },
    () => open,
    () => false,
  );
}
